import { render } from "./TokenCreated.vue?vue&type=template&id=77d75d58"
import script from "./TokenCreated.vue?vue&type=script&lang=js"
export * from "./TokenCreated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__